module.exports = __webpack_public_path__ + "img/tj.53e999f2.svg";